import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Container } from 'reactstrap';
import ListSearch from './listSearch';
import ListResult from './listResult';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { listRequest as listRequestAction, listClear as listClearAction, downloadRequest as downloadRequestAction } from '../../store/feedbacks/actions'
import { getFeedbacks } from '../../store/feedbacks/selectors';
import queryString from 'query-string'
// @ts-ignore
import { store } from 'react-notifications-component';
import {
    Button, Col, Row, Spinner, Form, FormGroup, Input,
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label
} from 'reactstrap';
import UserTopNav from '../../components/userTopNav';
import { timeStamp } from 'console';
import { GeneralUtil } from '../../utils/generalUtil'
import { findAllInRenderedTree } from 'react-dom/test-utils';
import { NONAME } from 'dns';

interface IState {
    term: string
    year : number
    sorting: string
    offset: number
    limit: number
}

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    userData : any
    data: any
    ui: any
    selectedUserId : string
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest: typeof listRequestAction
    downloadRequest: typeof downloadRequestAction
    listClear: typeof listClearAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class FeedbackMainPage extends React.Component<AllProps, IState> {
    downloadLink : any = {};

    constructor(props: AllProps) {
        super(props);
        let limit = this.props.ui?.searchParams?.limit ?? 10;
        if (limit === 1) limit = 10;
        this.state = {
            term: this.props.ui?.searchParams?.term ?? '',
            year : new Date().getFullYear(),
            sorting: this.props.ui?.searchParams?.sorting ?? '',
            offset: this.props.ui?.searchParams?.offset ?? 0,
            limit: limit
        };
        this.DownloadRequest = this.DownloadRequest.bind(this);
    }

    public componentDidMount() {
        const parsed = queryString.parse(this.props.route.location.search);
        const { searchParams: stateSP } = this.props.ui;

        var sTerm = '';
        var sYear = new Date().getFullYear();
        var sSorting = '';
        if (parsed.term) sTerm = parsed.term.toString();
        if (parsed.sorting) sSorting = parsed?.sorting.toString() ?? "Title";

        // Compare if different only query again
        let isNewSearch = true;
        if ((stateSP != undefined) && (
            stateSP.term === sTerm &&
            stateSP.pk === sYear && 
            stateSP.sorting === sSorting &&
            stateSP.offset === this.state.offset &&
            stateSP.limit === this.state.limit
        )) {
            isNewSearch = false;
        }

        if (isNewSearch) {
            this.setState({
                term: sTerm,
                year : sYear, 
                sorting: sSorting
            }, () => {
                this.ListRequest();
            });
        }
    }

    componentDidUpdate(prevProps: AllProps) {
        // Show notification
        let notification = { show: false, title: "", type: "", message: "" };
        if (prevProps.ui.processState != this.props.ui.processState) {

            if (this.props.ui.processState === 1) { // List success

            } else if (this.props.ui.processState === 2) { // List failed
                notification.show = true;
                notification.type = "danger";
                notification.message = "Process failed. Error : \n" + this.props.ui.errors;
            }
        }
        if (prevProps.ui.downloading === true && this.props.ui.downloading === false ) {
            if (this.props.ui.processState === 1) { // List success
                console.log("Download URL :" + this.props.ui.downloadURL);
                //window.URL.revokeObjectURL(this.props.ui.downloadUrl);
               // this.refs.download.click();
               this.downloadLink.click();
            } else if (this.props.ui.processState === 2) { // List failed
                notification.show = true;
                notification.type = "danger";
                notification.message = "Process failed. Error : \n" + this.props.ui.errors;
            }
        }

        if (notification.show) {
            store.addNotification({
                title: notification?.title ?? "Info",
                message: notification.message,
                type: notification.type,
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 3000,
                    showIcon: true
                }
            });
        }
    }

    public componentWillUnmount() {
    }

    private Search(d: any) {
        this.setState({
            offset: 0,
            year: d.year,
            term: d?.term ?? "".toLowerCase(),
        }, () => {
            this.props.route.history.push('?term=' + d.term + '&year=' + d.year +  '&sorting=' + this.state.sorting);
            this.ListRequest();
        });
    }
    private LoadMore(d: any) {
        this.setState({ offset: this.state.offset + this.state.limit }, () => {
            this.ListRequest();
        });
    }

    private Sorting(d: any) {
        this.setState({ offset: 0, sorting: d.searchSorting }, () => {
            this.props.route.history.push('?term=' + this.state.term + '&year=' + this.state.year + '&sorting=' + this.state.sorting);
            this.ListRequest();
        });
    }

    private ListRequest(){
        var searchParams: any = {};
        searchParams["term"] = this.state.term;
        searchParams["year"] = this.state.year;
        searchParams["sorting"] = this.state.sorting;
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        this.props.listRequest(searchParams);
    }
    
    private DownloadRequest(){
        var searchParams: any = {};
        searchParams["term"] = this.state.term;
        searchParams["year"] = this.state.year;
        searchParams["sorting"] = this.state.sorting;
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        this.props.downloadRequest(searchParams);
    }

    public render() {
        
        // const generalUtil: GeneralUtil = new GeneralUtil();
        // const download = async () => {
        //     let searchParams: any = {};
        //     searchParams.table = "UserCourse"; 
        //     searchParams["term"] = this.state.term;
        //     searchParams["year"] = this.state.year;
        //     searchParams["sorting"] = this.state.sorting;
        //     searchParams["offset"] = this.state.offset;
        //     searchParams["limit"] = this.state.limit;
        //     searchParams["feedbackSubmitted"] = true;
        //     await generalUtil.DownloadList(searchParams);
        // }

        const { ui } = this.props.ui;
        return (
            <Container>
                <ListSearch onSearch={this.Search.bind(this)} 
                    year={this.state.year}
                    term={this.state.term}
                    loading={this.props.ui.loading} />
                <br />
                <ListResult
                    selectedUserId ={this.props.selectedUserId} 
                    onLoadMore={this.LoadMore.bind(this)}
                    onSorting={this.Sorting.bind(this)}
                    onDownload={this.DownloadRequest.bind(this)}
                    downloading={this.props.ui.downloading}
                    term={this.state.term}
                    sorting={this.state.sorting}
                    data={this.props.data}
                    loading={this.props.ui.loading}
                    totalDocument={this.props.ui.totDoc}
                    offset={this.state.offset} limit={this.state.limit} />
                
                    <a ref={input => this.downloadLink = input} 
                        href={this.props.ui.downloadURL} download="feedback.csv" style={{display:"none"}}></a>
                    <br/><br/>
            </Container>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.feedback.ui,
    selectedUserId : state.user.ui.selected,
    data: getFeedbacks(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest: listRequestAction,
    downloadRequest: downloadRequestAction,
    listClear: listClearAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FeedbackMainPage)
